module.exports = __webpack_public_path__ + "static/media/moth-collection.34506063.mp4";